import React from "react";
import PropTypes from "prop-types";
import { IconButton } from "@material-ui/core";
import { ExpansionImage, DashImage } from "../../../images";

/**
 * ExpandIcon component for toggling expanded/collapsed states.
 * Shows a dash icon when expanded and an expansion icon when collapsed.
 *
 * @param {boolean} expanded - Whether the component is currently expanded
 * @param {function} onToggle - Callback function when icon is clicked, receives new expanded value
 * @param {boolean} disabled - Whether the icon button should be disabled
 * @param {string} className - Optional className for the container div
 */
function ExpandIcon({ expanded, onToggle, disabled, className }) {
  const handleClick = () => {
    onToggle(!expanded);
  };

  return (
    <div className={className}>
      {expanded === true && (
        <IconButton size="small" onClick={handleClick} disabled={disabled}>
          <DashImage />
        </IconButton>
      )}
      {expanded === false && (
        <IconButton size="small" onClick={handleClick} disabled={disabled}>
          <ExpansionImage />
        </IconButton>
      )}
    </div>
  );
}

ExpandIcon.propTypes = {
  expanded: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  className: PropTypes.string,
};

ExpandIcon.defaultProps = {
  disabled: false,
  className: "",
};

export default ExpandIcon;
